// extracted by mini-css-extract-plugin
export var autoExpand = "_3g-8";
export var container = "_3g-7";
export var containerWidth = "_3g-5";
export var disabled = "_3g-2";
export var error = "_3g-3";
export var fullWidth = "_3g-6";
export var inputWrapper = "_3g-0";
export var small = "_3g-1";
export var textarea = "_3g-4";